import React from 'react';
import './ScreenshotsPage.css';

const ScreenshotsPage: React.FC = () => {
  return (
    <div className="screenshots-page">
      <div className="screenshots-container">
        {/* Screenshot 1 - Positioning/Promise */}
        <div className="screenshot screenshot-1">
          <div className="screenshot-content">
            <div className="badge">1</div>
            <h1 className="headline">
              Learn Danish for <span className="highlight highlight-blue">real life</span> in Denmark
            </h1>
            <p className="supporting-text">
              PD2 · PD3 · Citizenship · Driving license · Daily conversations
            </p>
            <div className="mockup-container">
              <div className="phone-mockup">
                <div className="video-preview">
                  <div className="play-icon">▶</div>
                  <p className="video-text">Hvad laver du?</p>
                </div>
              </div>
            </div>
            <p className="bottom-line">
              Short videos, real Danish, fun quizzes — built for everyday life.
            </p>
          </div>
        </div>

        {/* Screenshot 2 - Targeted Learning */}
        <div className="screenshot screenshot-2">
          <div className="screenshot-content">
            <div className="badge">2</div>
            <h1 className="headline">
              Danish <span className="highlight highlight-green">tailored</span> to your goals
            </h1>
            <p className="supporting-text">
              Choose what you need — we focus your learning.
            </p>
            <div className="features-list">
              <div className="feature-item">
                <span className="bullet">•</span>
                <span>PD2 & PD3 exam preparation</span>
              </div>
              <div className="feature-item">
                <span className="bullet">•</span>
                <span>Medborgerskabsprøven & citizenship</span>
              </div>
              <div className="feature-item">
                <span className="bullet">•</span>
                <span>Driving license theory</span>
              </div>
              <div className="feature-item">
                <span className="bullet">•</span>
                <span>Daily Danish conversations</span>
              </div>
            </div>
            <div className="goal-cards">
              <div className="goal-card">PD2</div>
              <div className="goal-card">PD3</div>
              <div className="goal-card">Citizenship</div>
              <div className="goal-card">Daily Life</div>
            </div>
          </div>
        </div>

        {/* Screenshot 3 - How It Works */}
        <div className="screenshot screenshot-3">
          <div className="screenshot-content">
            <div className="badge">3</div>
            <h1 className="headline">
              Learn Danish with <span className="highlight highlight-yellow">short videos</span>
            </h1>
            <p className="supporting-text">
              Watch real Danish situations — then practice with fun quizzes.
            </p>
            <div className="mockup-container">
              <div className="phone-mockup large">
                <div className="quiz-preview">
                  <div className="quiz-question">Hvordan har du det?</div>
                  <div className="quiz-options">
                    <div className="quiz-option">How are you?</div>
                    <div className="quiz-option">Where are you?</div>
                    <div className="quiz-option">What do you want?</div>
                  </div>
                </div>
              </div>
            </div>
            <p className="micro-line">
              Listening · Speaking · Vocabulary
            </p>
          </div>
        </div>

        {/* Screenshot 4 - Outcome/Confidence */}
        <div className="screenshot screenshot-4">
          <div className="screenshot-content">
            <div className="badge">4</div>
            <h1 className="headline">
              Speak English with <span className="highlight highlight-orange">confidence</span>
            </h1>
            <p className="supporting-text">
              From the classroom to real conversations — faster and easier.
            </p>
            <div className="confidence-visual">
              <div className="progress-arrow">
                <span className="arrow-start">🎓 Beginner</span>
                <div className="arrow-line"></div>
                <span className="arrow-end">💬 Confident</span>
              </div>
            </div>
            <div className="testimonial">
              <div className="stars">⭐⭐⭐⭐⭐</div>
              <p className="testimonial-text">
                "I passed my PD3 exam thanks to Nemlingo!"
              </p>
              <p className="testimonial-author">— Maria, Copenhagen</p>
            </div>
            <p className="closing-line">
              Made for everyday Danish life in Denmark.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScreenshotsPage;